module.exports = __webpack_public_path__ + "static/diy_recipe_dropbear_snot_thumbnail-aee05973e11d99d1ee08054e59e53f3e.jpg";